import { useTheme } from '@mui/material'
import { IFlow, INode, NodeType } from '../../../definitions/Nodes'
import { IAcceptedData } from '../../../definitions/NodesDescription'
import NodeManager from '../../../managers/NodeManager'
import NodeReportEditor from './custom_editors/node_report_editor/NodeReportEditor'
import NodeSettlementEditor from './custom_editors/node_settlement_editor/NodeSettlementEditor'
import NodeVariableEditor from './custom_editors/node_variable_editor/NodeVariableEditor'
import NodeAggregateByEditor from './custom_editors/NodeAggregateByEditor'
import NodeCaseWhenEditor from './custom_editors/NodeCaseWhenEditor'
import NodeContractEditor from './custom_editors/NodeContractEditor'
import NodeDataframeFillEditor from './custom_editors/NodeDataframeFillEditor'
import NodeFilterByEditor from './custom_editors/NodeFilterByEditor'
import NodeForkEditor from './custom_editors/NodeForkEditor'
import NodeMergeEditor from './custom_editors/NodeMergeEditor'
import NodeOperationsEditor from './custom_editors/NodeOperationsEditor'
import NodeSubFlowEditor from './custom_editors/NodeSubFlowEditor'
import NodeBoolEditor from './NodeBoolEditor'
import NodeJSEditor from './NodeJSEditor'
import NodeJSONEditor from './NodeJSONEditor'
import NodeMultiSelectEditor from './NodeMultiSelectEditor'
import NodeSelectEditor from './NodeSelectEditor'
import NodeSQLEditor from './NodeSQLEditor'
import NodeTextEditor from './NodeTextEditor'

interface P {
    setSelected: React.Dispatch<React.SetStateAction<INode<NodeType>>>
    selectedNode: INode<NodeType>
    flow: IFlow
    disable: boolean
    onClose: () => void
}

function NodeEditor({ selectedNode, flow, setSelected, onClose, disable }: P) {
    const theme = useTheme()
    const description = NodeManager.getDescription(selectedNode.type)
    const acceptedData = description.acceptedData.map(x => x)

    const choiceEditor = (data: IAcceptedData<NodeType>) => {
        switch (data.type) {
            case 'js': return <NodeJSEditor acceptedData={data} selectedNode={selectedNode} setSelected={setSelected} disable={disable} flow={flow} />
            case 'sql': return <NodeSQLEditor acceptedData={data} flow={flow} selectedNode={selectedNode} setSelected={setSelected} disable={disable} />
            case 'json': return <NodeJSONEditor acceptedData={data} flow={flow} selectedNode={selectedNode} setSelected={setSelected} disable={disable} />
            case 'select': return <NodeSelectEditor acceptedData={data} selectedNode={selectedNode} setSelected={setSelected} disable={disable} />
            case 'multi-select': return <NodeMultiSelectEditor acceptedData={data} selectedNode={selectedNode} setSelected={setSelected} disable={disable} />
            case 'boolean': return <NodeBoolEditor acceptedData={data} selectedNode={selectedNode} setSelected={setSelected} disable={disable} />
            case 'custom': {
                switch (selectedNode.type) {
                    case 'stmt_settlement': return <NodeSettlementEditor acceptedData={data} selectedNode={selectedNode as INode<'stmt_settlement'>} setSelected={setSelected as (node: INode<'stmt_settlement'>) => void} disable={disable} flow={flow} />
                    case 'var_dataframe': return <NodeDataframeFillEditor acceptedData={data} selectedNode={selectedNode} setSelected={setSelected} disable={disable} />
                    case 'exe_subFlow': return <NodeSubFlowEditor selectedNode={selectedNode} setSelected={setSelected} disable={disable} flow={flow} onClose={onClose} />
                    case 'var_variable': return <NodeVariableEditor selectedNode={selectedNode as INode<'var_variable'>} setSelected={setSelected as (node: INode<'var_variable'>) => void} disable={disable} flow={flow} acceptedData={data as IAcceptedData<'var_variable'>} />
                    case 'fork': return <NodeForkEditor flow={flow} selectedNode={selectedNode as INode<'fork'>} setSelected={setSelected as (node: INode<'fork'>) => void} disable={disable} />
                    case 'xfrm_merge': return <NodeMergeEditor flow={flow} selectedNode={selectedNode as INode<'xfrm_merge'>} setSelected={setSelected as (node: INode<'xfrm_merge'>) => void} disable={disable} acceptedData={data} />
                    case 'xfrm_operations': return <NodeOperationsEditor flow={flow} selectedNode={selectedNode as INode<'xfrm_operations'>} setSelected={setSelected as (node: INode<'xfrm_operations'>) => void} disable={disable} acceptedData={data} />
                    case 'out_report': return <NodeReportEditor flow={flow} selectedNode={selectedNode as INode<'out_report'>} setSelected={setSelected as (node: INode<'out_report'>) => void} disable={disable} acceptedData={data} />
                    case 'xfrm_aggregateBy': return <NodeAggregateByEditor flow={flow} selectedNode={selectedNode as INode<'xfrm_aggregateBy'>} setSelected={setSelected as (node: INode<'xfrm_aggregateBy'>) => void} disable={disable} acceptedData={data} />
                    case 'xfrm_filterby': return <NodeFilterByEditor flow={flow} selectedNode={selectedNode as INode<'xfrm_filterby'>} setSelected={setSelected as (node: INode<'xfrm_filterby'>) => void} disable={disable} acceptedData={data} />
                    case 'xfrm_caseWhen': return <NodeCaseWhenEditor flow={flow} selectedNode={selectedNode as INode<'xfrm_caseWhen'>} setSelected={setSelected as (node: INode<'xfrm_caseWhen'>) => void} disable={disable} acceptedData={data} />
                    case 'ds_contract': return <NodeContractEditor flow={flow} selectedNode={selectedNode as INode<'ds_contract'>} setSelected={setSelected as (node: INode<'ds_contract'>) => void} disable={disable} acceptedData={data as IAcceptedData<'ds_contract'>} />
                    default: return null
                }
            }
            case 'multiline':
            case 'number':
            case 'string':
            default: return <NodeTextEditor acceptedData={data} type={data.type} selectedNode={selectedNode} setSelected={setSelected} disable={disable} flow={flow} />
        }
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'calc(var(--unit) * 3)', height: '100%', flex: 1, overflowY: 'auto' }}>
            {acceptedData.map((data, index) => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', flex: 0, marginTop: theme.spacing(1) }} key={'node-editor-' + index}>
                        {choiceEditor(data)}
                    </div>
                )
            })}
        </div>
    )
}

export default NodeEditor
